import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const WifiIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 50,
  height = 50,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <defs>
        <polygon id="wifi-path-1" points="0 0 8 0 8 8 0 8"></polygon>
      </defs>
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g transform="translate(1.000000, 7.000000)">
          <g transform="translate(19.000000, 29.000000)">
            <mask fill="#ffffff" className={styles.white} id="wifi-mask-1">
              <use xlinkHref="#wifi-path-1"></use>
            </mask>
            <path
              d="M8,4.00010038 C8,6.20944064 6.20928482,8.00020076 4,8.00020076 C1.79071518,8.00020076 0,6.20944064 0,4.00010038 C0,1.79076012 1.79071518,0 4,0 C6.20928482,0 8,1.79076012 8,4.00010038"
              fill="#0050B3"
              className={styles.interactiveColor}
              mask="url(#wifi-mask-1)"
            ></path>
          </g>
          <path
            d="M32.168725,28 C31.7478895,28 31.3252477,27.8389224 30.980271,27.5076497 C23.1433377,19.9937356 15.3407215,27.2006905 15.0129032,27.511702 C14.2425755,28.2411098 13.0884385,28.137777 12.4364143,27.2746444 C11.783487,26.4115118 11.872892,25.1228912 12.6396074,24.3863919 C16.2221281,20.9510834 25.1626259,16.5290483 33.3589852,24.3863919 C34.1275068,25.1239043 34.2178148,26.4196163 33.5603722,27.2817359 C33.19914,27.756864 32.6852871,28 32.168725,28"
            fill="#ffffff"
            className={styles.white}
          ></path>
          <path
            d="M32.168725,28 C31.7478895,28 31.3252477,27.8389224 30.980271,27.5076497 C23.1433377,19.9937356 15.3407215,27.2006905 15.0129032,27.511702 C14.2425755,28.2411098 13.0884385,28.137777 12.4364143,27.2746444 C11.783487,26.4115118 11.872892,25.1228912 12.6396074,24.3863919 C16.2221281,20.9510834 25.1626259,16.5290483 33.3589852,24.3863919 C34.1275068,25.1239043 34.2178148,26.4196163 33.5603722,27.2817359 C33.19914,27.756864 32.6852871,28 32.168725,28 Z"
            stroke="#000000"
            className={styles.defaultStrokeColor}
            strokeWidth="2"
          ></path>
          <path
            d="M41.0750273,20 C40.7144213,20 40.3490705,19.8924926 40.0245252,19.6684352 C22.1318257,7.27594897 8.73246663,19.0063103 8.17162943,19.5116955 C7.3621639,20.2391286 6.15033801,20.1376496 5.46233975,19.2856285 C4.77339254,18.4326027 4.86449299,17.1515568 5.66826475,16.4201047 C5.82674159,16.2754219 21.7617301,2.15377492 42.1293253,16.2603508 C43.0185038,16.8752528 43.2671321,18.1372086 42.6863667,19.0786517 C42.31722,19.6754684 41.7022919,20 41.0750273,20"
            fill="#ffffff"
            className={styles.white}
          ></path>
          <path
            d="M41.0750273,20 C40.7144213,20 40.3490705,19.8924926 40.0245252,19.6684352 C22.1318257,7.27594897 8.73246663,19.0063103 8.17162943,19.5116955 C7.3621639,20.2391286 6.15033801,20.1376496 5.46233975,19.2856285 C4.77339254,18.4326027 4.86449299,17.1515568 5.66826475,16.4201047 C5.82674159,16.2754219 21.7617301,2.15377492 42.1293253,16.2603508 C43.0185038,16.8752528 43.2671321,18.1372086 42.6863667,19.0786517 C42.31722,19.6754684 41.7022919,20 41.0750273,20 Z"
            stroke="#000000"
            className={styles.defaultStrokeColor}
            strokeWidth="2"
          ></path>
          <path
            d="M46.08263,11 C45.7281466,11 45.369882,10.9011587 45.049429,10.6939723 C21.4294895,-4.56084444 3.33098374,10.3926965 3.15043352,10.5457104 C2.34410189,11.229996 1.13507709,11.1302043 0.451633046,10.3166648 C-0.230865707,9.50407566 -0.127829192,8.28946874 0.679447727,7.60233196 C0.881739601,7.43126056 21.1515745,-9.3185301 47.1196122,7.45407008 C48.0100746,8.02906005 48.2671932,9.21990706 47.6962386,10.1151807 C47.3304117,10.6882699 46.7131379,11 46.08263,11"
            fill="#ffffff"
            className={styles.white}
          ></path>
          <path
            d="M46.08263,11 C45.7281466,11 45.369882,10.9011587 45.049429,10.6939723 C21.4294895,-4.56084444 3.33098374,10.3926965 3.15043352,10.5457104 C2.34410189,11.229996 1.13507709,11.1302043 0.451633046,10.3166648 C-0.230865707,9.50407566 -0.127829192,8.28946874 0.679447727,7.60233196 C0.881739601,7.43126056 21.1515745,-9.3185301 47.1196122,7.45407008 C48.0100746,8.02906005 48.2671932,9.21990706 47.6962386,10.1151807 C47.3304117,10.6882699 46.7131379,11 46.08263,11 Z"
            stroke="#000000"
            className={styles.defaultStrokeColor}
            strokeWidth="2"
          ></path>
        </g>
      </g>
    </Icon>
  )
}
